import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.createTermOrMethod.createTermOrMethodForm`

export default defineMessages({
  kindLabelShippingTerms: {
    id: `${scope}.kindLabelShippingTerms`,
    defaultMessage: 'Shipping terms',
  },
  kindLabelPaymentTerms: {
    id: `${scope}.kindLabelPaymentTerms`,
    defaultMessage: 'Payment terms',
  },
  kindLabelShippingMethods: {
    id: `${scope}.kindLabelShippingMethods`,
    defaultMessage: 'Shipping method',
  },
  nameLabel: {
    id: `${scope}.nameLabel`,
    defaultMessage: '{kindLabel} name',
  },
  nameRequiredError: {
    id: `${scope}.nameRequiredError`,
    defaultMessage: '{kindLabel} name is required',
  },
  descriptionLabel: {
    id: `${scope}.descriptionLabel`,
    defaultMessage: '{kindLabel} description',
  },
  descriptionRequiredError: {
    id: `${scope}.descriptionRequiredError`,
    defaultMessage: '{kindLabel} description is required',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  addButton: {
    id: `${scope}.addButton`,
    defaultMessage: 'Add',
  },
})
